import type { SvgIconComponent } from "@mui/icons-material";
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined";
import DynamicFeedOutlinedIcon from "@mui/icons-material/DynamicFeedOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import EventRepeatRoundedIcon from "@mui/icons-material/EventRepeatRounded";
import PanToolAltOutlinedIcon from "@mui/icons-material/PanToolAltOutlined";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import PhoneDisabledOutlinedIcon from "@mui/icons-material/PhoneDisabledOutlined";
import { ACTION_NAME_VALUES, BULK_UPDATE_ACTION_NAME } from "../../pages/ActivityLog/GroupedActivityLog/activityLogGroupedDisplay";

export const SHIFT_HISTORY_TEST_ID = "shift-history";

/** Recurring shifts are generated about three months ahead, so no shift's history starts earlier than this. */
export const SHIFT_HISTORY_LOOKBACK_DAYS = 180;

type ActionName = (typeof ACTION_NAME_VALUES)[number];

const ACTION_ICON: Record<ActionName, SvgIconComponent> = {
	"User Status": PersonOutlineRoundedIcon,
	"Call Off": PhoneDisabledOutlinedIcon,
	PTO: BeachAccessOutlinedIcon,
	Request: PanToolAltOutlinedIcon,
	Recurring: EventRepeatRoundedIcon,
	Shift: EventNoteOutlinedIcon,
	Other: EditNoteOutlinedIcon,
	[BULK_UPDATE_ACTION_NAME]: DynamicFeedOutlinedIcon,
};

const isActionName = (value: string): value is ActionName => (ACTION_NAME_VALUES as readonly string[]).includes(value);

export const actionIcon = (actionName: string): SvgIconComponent => {
	if (!isActionName(actionName)) throw new Error(`Shift history has no icon for action "${actionName}"`);
	return ACTION_ICON[actionName];
};
